import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser, userSelector } from "../../redux/slices/userSlice";
import { CgClose } from "react-icons/cg";
import { FaPlay } from "react-icons/fa";

const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const dispatch = useDispatch();
  const userData = useSelector(userSelector);

  const welcomeVideo = userData?.welcomeVideo?.video;
  const isWelcomeVideoWatch = userData?.isWelcomeVideoWatch;

  useEffect(() => {
    const isWatched = sessionStorage.getItem("isWelcomeVideoWatched");
    if (!isWatched && isWelcomeVideoWatch === null && welcomeVideo) {
      setIsOpen(true);
    }
  }, [isWelcomeVideoWatch, welcomeVideo]);

  const closeModal = () => {
    setIsOpen(false);
    sessionStorage.setItem("isWelcomeVideoWatched", "true");
    dispatch(setUser({ ...userData, isWelcomeVideoWatch: true }));
  };

  const handlePlay = () => {
    setIsPlaying(true);
    videoRef.current?.play();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center transition-colors z-[51] bg-site-black/60 p-4">
      <div className="relative bg-white rounded-lg shadow transition-all w-full max-w-[90vw] sm:max-w-[500px] max-h-[90vh] overflow-y-auto scale-100 opacity-100">
        {welcomeVideo && (
          <div className="relative w-full aspect-video">
            {!isPlaying && (
              <div
                className="absolute inset-0 bg-black/40 flex items-center justify-center z-10 cursor-pointer rounded-lg"
                onClick={handlePlay}
              >
                <FaPlay size={24} color="#fff" className="sm:size-8 md:size-10" />
              </div>
            )}
            <video
              ref={videoRef}
              controls={isPlaying}
              className="w-full h-full rounded-lg object-contain"
              onEnded={closeModal}
              playsInline
              poster={userData?.welcomeVideo?.imageUrl}
            >
              <source src={welcomeVideo} type="video/mp4" />
            </video>
          </div>
        )}
        <button
          onClick={closeModal}
          className="absolute right-2 top-2 z-20 rounded-md text-grey-400 bg-white hover:bg-grey-500 hover:text-grey-600 p-1"
        >
          <CgClose size={16} color="#333333" className="sm:size-5 md:size-6" />
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;